import { Button } from 'components';
import ErrorView from 'components/ErrorView';
import bugsnagClient from '../containers/BugsnagClient';
import { useEffect } from 'react';

const errorTypes = { unauthorized: 'unauthorized' };
const noNotifyErrorTypes = [errorTypes.unauthorized];

function SupportMailTo() {
    return <a href="mailto:support@spate.nyc">support@spate.nyc</a>;
}

function AuthErrorView({ error, loginWithRedirect }) {
    const notify = !noNotifyErrorTypes.includes(error.error);

    useEffect(() => {
        if (error && notify) bugsnagClient.notify(error);
    }, [error, notify]);

    if (error.error === errorTypes.unauthorized)
        return (
            <ErrorView>
                <h2>Oops! There may be an issue.</h2>
                <p>Access to this account has been suspended.</p>
                <p>
                    To restore access, contact us at <SupportMailTo />.
                </p>
            </ErrorView>
        );

    return (
        <ErrorView>
            <h2>Unable to log in</h2>
            <p>Error details: &quot;{error.message}&quot;</p>
            <p>
                Please try logging in again or contact us at <SupportMailTo />.
            </p>
            <Button onClick={() => loginWithRedirect()}>Log in</Button>
        </ErrorView>
    );
}

export default AuthErrorView;
